<div class="main-page-content">
  <div class="main-page-content-block">



    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                  sortField="LastLogDate" [sortOrder]="-1"
                 [(selection)]="selectedItems"
                 (selectionChange)="onSelectionChange($event)"
                 [expandedRowKeys]="expandedRows"
                 (onRowExpand)="onRowExpand($event)"
                 (onRowCollapse)="onRowCollapse($event)">

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end ">

              <div class="p-2 flex-fill"><h1 class="content-heading-font">Exception Logs</h1></div>
              <div class="ml-auto">
                <button class="btn btn-primary " (click)="showLinkTicketSelected()" title="Link Support Ticket">
                  <i class="pi pi-link" [ngClass]="{'pi-spin': loading}"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="showLinkGitHubSelected()" title="Link Github Issue">
                  <i class="pi pi-paperclip" [ngClass]="{'pi-spin': loading}"></i>
                </button>
                &nbsp;
                <button class="btn btn-danger " (click)="deleteSelected()" title="Delete Selected">
                  <i class="pi pi-trash" [ngClass]="{'pi-spin': loading}"></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="selectedAll()" title="Select All">
                  <i class="pi pi-list-check" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="selectedNone()" title="Select None">
                  <i class="pi pi-list" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="expandAll()" title="Expand All">
                  <i class="pi pi-plus-circle" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="collapseAll()" title="Collapse All">
                  <i class="pi pi-minus-circle" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
                  <i class="pi pi-filter-slash"></i>
                </button>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-end d-none d-xxl-table-cell" style="width:70px;">#</th>
              <th class="text-center" style="width:70px;"></th>
              <th pSortableColumn="LastLogDate" class="text-center" style="width:130px;">
                Time<p-sortIcon field="LastLogDate"></p-sortIcon>
                <p-columnFilter type="date" field="LastLogDate" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="DuplicateCount" class="text-center d-none  d-sm-table-cell" style="width:130px;">
                Count <p-sortIcon field="DuplicateCount"></p-sortIcon>
                <p-columnFilter type="numeric" field="DuplicateCount" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="ApplicationName" class="text-start d-none d-xxl-table-cell" style="min-width:210px;">
                Application Name
                <p-sortIcon field="ApplicationName"></p-sortIcon>
                <p-columnFilter type="text" field="ApplicationName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Type" class="text-start d-none d-lg-table-cell" style="min-width: 130px;">
                Type<p-sortIcon field="Type"></p-sortIcon>
                <p-columnFilter type="text" field="Type" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Message" class="text-start d-none d-md-table-cell" style="min-width: 160px;">
                Message<p-sortIcon field="Message"></p-sortIcon>
                <p-columnFilter type="text" field="Message" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Host" class="text-start d-none d-xxl-table-cell" style="min-width: 130px;">
                Host<p-sortIcon field="Host"></p-sortIcon>
                <p-columnFilter type="text" field="Host" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Url" class="text-start d-none d-xl-table-cell">
                Url<p-sortIcon field="Url"></p-sortIcon>
                <p-columnFilter type="text" field="Url" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="GitHub_IssueNumber" class="text-center d-none d-xxxl-table-cell" style="width:160px;">
                Git / Ticket   <p-sortIcon field="GitHub_IssueNumber"></p-sortIcon>
                <p-columnFilter type="numeric" field="GitHub_IssueNumber" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-expanded="expanded">
            <tr>
              <th class="text-end d-none d-xxl-table-cell">
                <a href="#" [routerLink]="['/exceptionlog/'+  item.ID[0] ]">
                  {{ item.ID[0] }}
                  <span *ngIf="item.ID.length>1">({{ item.ID.length }})</span>
                </a>
              </th>
              <td class="text-center text-nowrap ">
                <div style="height: 2.357rem; vertical-align: middle; display: inline-block " class="me-2">
                  <p-tableCheckbox [value]="item" />
                </div>
                <p-button type="button" pRipple [pRowToggler]="item" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
              </td>
              <td class="text-center text-nowrap ">
                <span title="{{ item.LastLogDate | date: 'short' }}"> {{ getTimeFromNow(item.LastLogDate) }}</span>
              </td>
              <td class="text-center  d-none d-sm-table-cell fw-bold ">
                <div [ngClass]="{'text-primary': item.DuplicateCount>1, 'text-secondary': item.DuplicateCount<=1}">
                  {{ item.DuplicateCount }}
                </div>
              </td>
              <td class=" text-break d-none d-xxl-table-cell text-truncate " style="max-width: 10vw;">
                {{ item.ApplicationName }}
              </td>
              <td class=" d-none d-lg-table-cell text-break text-truncate " style="max-width: 10vw;">
                {{ item.Type }}
              </td>
              <td class="text-break d-none d-md-table-cell text-truncate " style="max-width: 30vw;">
                <a href="#" [routerLink]="['/exceptionlog/'+  item.ID[0] ]">
                  {{ item.Message }}
                </a>
              </td>
              <td class=" d-none d-xxl-table-cell text-break text-truncate " style="max-width: 10vw;">
                {{ item.Host }}
              </td>
              <td class=" d-none d-xl-table-cell text-break text-truncate " style="max-width: 10vw;">
                <a href="https://{{ item.Host }}{{ item.Url }}" target="_blank">
                  {{ item.Url }}
                </a>
              </td>
              <td class="text-center d-none d-xxxl-table-cell ">
                <a href="https://github.com/UTBS/{{ item?.GitHub_Repository }}/issues/{{ item?.GitHub_IssueNumber }}">
                  {{ item.GitHub_IssueNumber |  number  }}
                </a>
                <a href="#" [routerLink]="['/tickets/'+item.SupportTicketID]">
                  {{ item.SupportTicketID |  number  }}
                </a>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No items found.</td>
            </tr>
          </ng-template>


          <ng-template pTemplate="expandedrow" let-item>
            <tr>
              <td colspan="10">
                <div class="card w-100">
                  <div class="card-body">
                    <h5 class="card-title">#{{ item.ID }} {{item.ApplicationName }}</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      {{formatMountainTime(item.LastLogDate)}}
                    </h6>
                    <p class="card-text">
                      {{ item.Type }}: {{ item.Message }}
                    </p>
                  </div>

                  <ul class="list-group list-group-flush ">
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.Host">
                      <b>HTTP {{ item.HTTPMethod }}</b>
                      <a href="https://{{ item.Host }}{{ item.Url }}" class="ms-2" target="_blank">{{ item.Host }}{{ item.Url }}</a>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.IPAddress">
                      <b>IP Address</b>
                      <span class="ms-2">{{ item.IPAddress }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.Source">
                      <b>Source </b> <span class="ms-2" title="{{ item.MachineName }}">{{ item.Source }} </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.DuplicateCount!=1">
                      <b>First Log Date</b><span class="ms-2">
                      {{formatMountainTime(item.CreationDate) }}
                      <span class="badge bg-info badge-info badge-pill">{{ item.DuplicateCount }}</span>
                    </span>

                    </li>
                  </ul>
                  <div class="card-footer d-flex justify-content-center ">
                    <button class="btn btn-primary me-2" type="button" id="btnGithub" [class.button-loading]="loading" (click)="showLinkGitHub(item)">GitHub Issue</button>
                    <button class="btn btn-primary me-2" type="button" id="btnTicket" [class.button-loading]="loading" (click)="showLinkTicket(item)">Support Ticket</button>



                    <a href="#" class="btn btn-primary me-2" [routerLink]="['/exceptionlog/'+  item.ID ]">View</a>
                    <button class="btn btn-danger" type="button" [class.button-loading]="loading" (click)="delete(item)">Delete</button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>
</div>





<p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubIssue">Issue</label><br />
      <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
        <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
          {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubComment">Comment</label><br />
      <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>





<p-dialog header="Link Support Ticket" [modal]="true" [(visible)]="ticketVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="ticket">Ticket</label><br />
      <select id="ticket" [(ngModel)]="ticket" [class.div-loading]="loadingTicket" class="form-control">
        <option *ngFor="let ticket of tickets" [ngValue]="ticket">
          {{ticket.Client}} - {{ticket.ID}} -  {{ticket.Subject}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnTicketConfirm" [class.button-loading]="loading" (click)="linkTicket()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnTicketCancel" [class.button-loading]="loading" (click)="ticketVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>

